import { DELIVERY_STATUSES } from "@/plugins/data";

export const isWaitingForPaymentDeliveryOrder = order => order.status === DELIVERY_STATUSES.STATUS_WAITING_FOR_PAYMENT;
export const isNewDeliveryOrder = order => order.status === DELIVERY_STATUSES.STATUS_NEW;
export const isAcceptedDeliveryOrder = order => order.status === DELIVERY_STATUSES.STATUS_ACCEPTED;
export const isCancelledDeliveryOrder = order => order.status === DELIVERY_STATUSES.STATUS_CANCELLED;
export const isBeingCompletedDeliveryOrder = order => order.status === DELIVERY_STATUSES.STATUS_BEING_COMPLETED;
export const isCompletedDeliveryOrder = order => order.status === DELIVERY_STATUSES.STATUS_COMPLETED;
